module.exports = __webpack_public_path__ + "static/media/sponsorship-app-logo.b5d8a3a0.jpg";